module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/TM-78762325c273d59969a7112e2c089b85.png";